import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AppLayout } from './components/Layout.jsx';
import { useSession } from './store.js';
import BrandPerformance from './screens/BrandPerformance.jsx';
import Contacts from './screens/Contacts.jsx';
import EngineQuality from './screens/EngineQuality.jsx';
import Login from './screens/Login.jsx';
import Overview from './screens/Overview.jsx';
import PromptVersions from './screens/PromptVersions.jsx';
import TeamApprovals from './screens/TeamApprovals.jsx';

function RequireAuth({ children }) {
  const ready = useSession((s) => s.isReady());
  const location = useLocation();
  if (!ready) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <AppLayout>
              <Routes>
                <Route index element={<Overview />} />
                <Route path="contacts" element={<Contacts />} />
                <Route path="brands" element={<BrandPerformance />} />
                <Route path="engines" element={<EngineQuality />} />
                <Route path="prompts" element={<PromptVersions />} />
                <Route path="approvals" element={<TeamApprovals />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AppLayout>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
